export function getThemeFileUri(path) {
    return `${window.application.themeFileUri}/${path}`;
}

export function isCheckout() {
    const location = document.location.pathname;
    const variations = [
        '/kassa/',
        '/kassa',
        'kassa',
        'kassa/',
        '/presentkortskassa/',
        '/presentkortskassa',
        'presentkortskassa',
        'presentkortskassa/',
        '/varukorg/',
        '/varukorg',
        'varukorg',
        'varukorg/',
    ];

    return variations.indexOf(location) > -1;
}

export function translate(key) {
    return application.i18n[key] || key;
}

export function _translate(key) {
    return translate(key).toLowerCase();
}
